import React, { memo } from 'react';
import { Loading } from '@carbon/react';
import { PageTitleBar } from 'carbon-addons-iot-react';

import './_override.scss';

const Page = memo(
  ({
    pageTitle,
    children,
    breadcrumb,
    description = '',
    rightContent,
    isLoading = false,
  }) => {
    return (
      <div className="page-padding">
        <PageTitleBar
          breadcrumb={breadcrumb}
          collapsed={false}
          description={description}
          editable={false}
          extraContent={undefined}
          i18n={{
            editIconDescription: 'Edit page title',
            tooltipIconDescription: 'More information',
          }}
          isLoading={false}
          onEdit={null}
          rightContent={rightContent}
          tabs={undefined}
          title={pageTitle}
        />
        <div className="page-content">
          {children}
          {isLoading && <Loading/>}
        </div>
      </div>
    );
  }
);

export default Page;
